import { useApolloClient, useQuery } from '@graphcommerce/graphql'
import { CustomerTokenDocument } from '@graphcommerce/magento-customer'
import Image from 'next/image'
import { useCallback, useEffect, useState } from 'react'
import { SocialSignInsDocument } from '../Customer/SignInSocial/SocialSignIns.gql'
import google from '../Customer/SignInSocial/google.svg'

export function ChatSignInGoogle() {
  const client = useApolloClient()
  const [error, setError] = useState<string | null>(null)

  const { data, loading } = useQuery(SocialSignInsDocument, { fetchPolicy: 'no-cache' })
  const googleEntry = data?.amSocialLoginButtonConfig?.find((s) => s?.type === 'google')
  const url = googleEntry?.url

  const handleMessageEvent = useCallback(
    (event: MessageEvent) => {
      if (event.data?.result === 1 && event.data?.token) {
        client.cache.writeQuery({
          query: CustomerTokenDocument,
          data: {
            customerToken: {
              token: event.data.token,
              __typename: 'CustomerToken',
              createdAt: new Date().toUTCString(),
              valid: true,
            },
          },
        })
      } else if (event.data?.messages?.at(0)) {
        setError(event.data.messages[0] as string)
      }
    },
    [client],
  )

  useEffect(() => {
    window.addEventListener('message', handleMessageEvent, false)
    return () => window.removeEventListener('message', handleMessageEvent, false)
  }, [handleMessageEvent])

  const openPopup = useCallback(() => {
    if (!url) return
    const w = 450
    const h = 450
    const left = (screen.width - w) / 2
    const top = (screen.height - h) / 4
    window.open(
      `${url}&generateToken=true&isAjax=1`,
      'Google Sign In',
      `resizable=yes, width=${w}, height=${h}, top=${top}, left=${left}`,
    )
  }, [url])

  if (loading || !url) return null

  return (
    <div className='flex flex-col gap-1'>
      <button
        type='button'
        onClick={openPopup}
        className='flex w-full items-center justify-center gap-2 rounded-[14px] bg-[rgba(120,120,128,0.08)] px-5 py-3.5 text-[17px] font-medium text-black transition-all active:scale-[0.98] hover:bg-[rgba(120,120,128,0.14)]'
      >
        <Image src={google} alt='Google' className='h-3.5 w-3.5' unoptimized />
        Sign in with Google
      </button>
      {error && <p className='mt-1 text-center text-[13px] text-[#FF3B30]'>{error}</p>}
    </div>
  )
}
